export const state = {
    location: null,
    group: null,
    type: null,
    devices: []
}

export const getters = {
    location: state => state.location,
    devices: state => state.devices,
    group: state => state.group,
    type: state => state.type,
}

export const mutations = {
    setLocation (state, { id, name }) {
        state.location = { id, name }
        state.type = 'location'
    },
    setGroup (state, { id, name }) {
        state.group = { id, name }
        state.type = 'group'
    },
    setDevices (state, devicesArray) {
        state.devices = devicesArray
    },
}

export const actions = {
    async setLocation ({ commit }, { id, name }) {
        commit('setLocation', { id, name });
    },
    async setGroup ({ commit }, { id, name }) {
        commit('setGroup', { id, name });
    },
    async setDevices ({ commit }, devices) {
        commit('setDevices', devices);
    },
}
